import { render, staticRenderFns } from "./SubSection.vue?vue&type=template&id=ac4a7e54&scoped=true&"
import script from "./SubSection.vue?vue&type=script&lang=js&"
export * from "./SubSection.vue?vue&type=script&lang=js&"
import style0 from "./SubSection.vue?vue&type=style&index=0&id=ac4a7e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4a7e54",
  null
  
)

export default component.exports